// extracted by mini-css-extract-plugin
export default {"TimelineRow":"FileHistory-module__TimelineRow__h9igkBp"};